module.exports = __webpack_public_path__ + "img/jslc6.30d86cc1.png";